import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useLocation, useNavigate } from "react-router-dom";
import classnames from 'classnames';

import { changeUserPasswordOld, /*confirmResetPassword*/ } from '../../../../action/AccountActions';
import { passwordValidation } from '../../../helpers/helperAccount';
import CustomButton from '../../../CustomButton';
import { toastr } from 'react-redux-toastr';

const ResetPasswordForm = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { toggleLoader } = props;
    // const { state } = location;

    // ToDo: Cognito - disable
    // useEffect(() => {
    //     if (!state?.email) {
    //         navigate('/restore-password');
    //     }
    // }, []);

    const [data, setData] = useState({
        // confirmation_code: '',
        new_password: '',
        new_password_confirm: '',
    })
    const [errMessage, setErrMessage] = useState({
        // confirmation_code: '',
        new_password: '',
        new_password_confirm: '',
    })
    const [toggle_password, setToggle_password] = useState(true)
    const [toggle_password_confirm, setToggle_password_confirm] = useState(true)
    const [disabledSave, setDisabledSave] = useState(true);

    const togglePassword = () => {
        setToggle_password(!toggle_password);
    }

    const togglePassword2 = () => {
        setToggle_password_confirm(!toggle_password_confirm);
    }

    const handleInputChange = (e) => {
        const newData = { ...data, [e.target.name]: e.target.value };
        setData(newData);
        (!data.new_password && !data.new_password_confirm/* && !data.confirmation_code*/) ? setDisabledSave(true) : setDisabledSave(checkForm(newData));
    }

    const checkForm = (data) => {
        let error = false;
        const updatedErrMessage = { ...errMessage };

        for(let i in data){
            if(data[i] == ''){
                error = true;
                updatedErrMessage[i] = /*'confirmation_code' ? 'Enter your confirmation code!' : */'Enter your password!';
            }
            else if(updatedErrMessage[i]){
                updatedErrMessage[i] = null;
            }
        }

        if (!updatedErrMessage.new_password) {
			const validation = passwordValidation(data.new_password)
			if (!validation.result) {
                error = true;
                updatedErrMessage.new_password = validation.error;
            }
			else if (data.new_password !== data.new_password_confirm) {
				error = true;
                updatedErrMessage.new_password = 'Passwords do not match';
            }
        }

        if (!updatedErrMessage.new_password_confirm) {
			if (data.new_password !== data.new_password_confirm) {
                error = true;
                updatedErrMessage.new_password_confirm = 'Passwords do not match';
            }
        }

        setErrMessage(updatedErrMessage);
        return error;
    }

    const sendForm = (e) => {
        e.preventDefault()

        // ToDo: Cognito - disable
        const queryParams = new URLSearchParams(location.search);
        const params = {
            token: queryParams.get('token'),
            // email: state.email,
            // confirmation_code: data.confirmation_code,
            new_password: data.new_password,
            new_password_confirm: data.new_password_confirm
        };
        const error = checkForm(params);
        if(!error){
            toggleLoader(true);

            // confirmResetPassword(params)
            changeUserPasswordOld(params)
                .then((res, err)=>{
                    toggleLoader(false);
                    toastr.success('You have successfully changed your password.')
                    navigate('/login');
                })
                .catch((error,p)=>{
                    toggleLoader(false);
                    if (error.response.data.response.error) {
                        toastr.error(error.response.data.response.error)
                    }
                });
        }
    }

    const { /*confirmation_code, */new_password, new_password_confirm } = errMessage;

    return(
        <div className="panel-body">
            <h3 className='login-header'>Reset Password</h3>
            <div className="form-wrapper">
                <form autoComplete="off"  onSubmit={sendForm}>
                    {/*<div className={classnames('login-form form-group has-feedback', { 'error': confirmation_code })}*/}
                    {/*     style={{ marginTop: '30px', maxHeight: '54px', paddingTop: '17px' }}>*/}
                    {/*    <input*/}
                    {/*        type="text"*/}
                    {/*        name="confirmation_code"*/}
                    {/*        autoComplete="one-time-code"*/}
                    {/*        className={`vehicle-search ${confirmation_code ? 'error' : ''}`}*/}
                    {/*        placeholder="Confirmation Code"*/}
                    {/*        onChange={handleInputChange}*/}
                    {/*    />*/}
                    {/*    {confirmation_code && <span className="help-block error-label">{confirmation_code}</span>}*/}
                    {/*</div>*/}
                    <div className={classnames('login-form form-group has-feedback', { 'error': new_password })} style={{ maxHeight: '54px' }}>
                        <input type={toggle_password ? "password" : "text"} autoComplete="off" name="new_password" className={`vehicle-search ${new_password ? 'error' : ''}`}
                               placeholder='New Password' onChange={handleInputChange}/>
                        <span className="fa fa-eye form-control-feedback" onClick={togglePassword}></span>
                        {new_password && <span className="help-block error-label">{new_password}</span>}
                    </div>
                    <div className={classnames('login-form form-group has-feedback', { 'error': new_password_confirm })} style={{ maxHeight: '54px' }}>
                        <input type={toggle_password_confirm ? "password" : "text"} autoComplete="off" name="new_password_confirm"
                               className={`vehicle-search ${new_password_confirm ? 'error' : ''}`} placeholder='Confirm Password' onChange={handleInputChange}/>
                        <span className="fa fa-eye form-control-feedback" onClick={togglePassword2}></span>
                        {new_password_confirm && <span className="help-block error-label">{new_password_confirm}</span>}
                    </div>

                    <div className="change-password-submit form-group submit-btn">
                        <CustomButton variant="primary" size="lg" value="Submit" type="submit"
                                      id="restore-button" disabled={disabledSave}>Save Password</CustomButton>
                    </div>
                </form>

            </div>
        </div>

    )
}

export default connect(
    null,
    dispatch => ({
        toggleLoader: (show) => {
            dispatch({ type: 'TOGGLE_LOADER', payload: show });
        }
    })
)(ResetPasswordForm)
